import DatePicker from "react-datepicker";
import React,{useState,useEffect} from "react";
import { ErrorMessage } from "formik";
import { Form } from "react-bootstrap";
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";
import "react-datepicker/dist/react-datepicker.css";
import "./InputField.styles.css";

const CustomDateTimePicker = ({
  Labels,
  Name,
  minDate,
  Classname,
  Placeholder,
  value,
  onChange,
  isInvalid,
  startYear,
  ReadOnly=false
}) => {
  const [startDate, setStartDate] = useState(new Date());
  const years = range(startYear??2010, getYear(new Date()) + 10, 1);
  
  // useEffect(()=>{
  //   console.log(value)
  // },[value])

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    <Form.Group className={Classname}>
      <Form.Label>{Labels}</Form.Label>
      <DatePicker
        name={Name}
        // readOnly={ReadOnly}
        // value={value}
        // isInvalid={isInvalid}
        // placeholder={Placeholder}
        className={'form-control'}
        minDate={minDate??false}
        // onChange={(date) => {setStartDate(date);}}
        onChange={onChange}
        placeholderText="Select a Date"
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            style={{
              margin: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            <i className="fa fa-angle-left" style={{fontSize:"16px",fontWeight:"bold"}} aria-hidden="true"></i>
            </button>
            <select
              value={getYear(date)}
              onChange={({ target: { value } }) => changeYear(value)}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <select
              value={months[getMonth(date)]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              <i className="fa fa-angle-right" style={{fontSize:"16px",fontWeight:"bold"}} aria-hidden="true"></i>
            </button>
          </div>
        )}
        selected={value}
      />
      {/* <ErrorMessage
          name={Name}
          component="div"
          style={{ color: "red", marginBottom: "2px" }}
        /> */}
    </Form.Group>
  );
};

export default CustomDateTimePicker;
